import React from 'react';
import { BONUS_CLOSING, BONUS_EYEBROW, BONUS_SUB, BONUS_TITLE, bonuses } from '../data/halloweenKit';
import type { Bonus } from '../data/halloweenKit';
export function BonusesSection() {
  return <section className="w-full bg-night-950 py-14 sm:py-20" aria-labelledby="bonuses-title" data-id="element-14" data-mp="vtfm748ccjkr">
      <div className="mx-auto max-w-6xl px-5" data-id="element-15" data-mp="qta0e4or5ral">
        <p className="text-center" data-id="element-16" data-mp="qsi1okzuzdg3">
          <span className="inline-block rounded-full bg-pumpkin px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-night-950" data-id="element-17" data-mp="14tazpfpdcqny">
            {BONUS_EYEBROW}
          </span>
        </p>
        <h2 id="bonuses-title" className="mx-auto mt-4 max-w-3xl text-center font-display text-[1.75rem] font-semibold leading-tight text-cream-50 sm:text-[2.6rem]" data-id="element-18" data-mp="1ej4awflln3ro">
          {BONUS_TITLE}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed text-body sm:text-[16px]" data-id="element-19" data-mp="1nl3thcc9ifwq">{BONUS_SUB}</p>

        <div className="mt-10 space-y-6 sm:space-y-8" data-id="element-20" data-mp="1jkbj2frnm4yv">
          {bonuses.map((b, i) => <BonusCard key={b.label} bonus={b} reversed={i % 2 === 1} data-id="element-21" data-mp="3prwmixz3m9xe" data-mpi={i} />)}
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-semibold leading-snug text-cream-50 sm:text-2xl" data-id="element-22" data-mp="3tsfeqt4wli04">
          {BONUS_CLOSING}
        </p>
      </div>
    </section>;
}
function BonusCard({
  bonus,
  reversed
}: {
  bonus: Bonus;
  reversed: boolean;
}) {
  return <article className="grid items-center overflow-hidden rounded-3xl border border-pumpkin/25 bg-night-800 md:grid-cols-[1.25fr_1fr]" data-id="element-23" data-mp="cj0kmya58vb8">
      <img src={bonus.image.src} alt={bonus.image.alt} width={bonus.image.width} height={bonus.image.height} loading="lazy" className={`block h-auto w-full object-contain ${reversed ? 'md:order-2' : ''}`} data-id="element-24" data-mp="gj0zgk15n8it" />

      <div className="p-6 sm:p-8" data-id="element-25" data-mp="vbl11g8np7y5">
        <p className="text-[11px] font-bold uppercase leading-snug tracking-[0.16em] text-pumpkin" data-id="element-26" data-mp="v8gn3r5e2xua">{bonus.label}</p>
        <h3 className="mt-3 font-display text-[1.55rem] font-semibold leading-tight text-cream-50 sm:text-[1.9rem]" data-id="element-27" data-mp="akz763pjp6mc">
          {bonus.title}
        </h3>
        <div className="mt-3 space-y-2.5" data-id="element-28" data-mp="5npb457nhwpj">
          {bonus.copy.map(p => <p key={p} className="text-[15px] leading-relaxed text-body" data-id="element-29" data-mp="kc3j0ujxcbcy">
              {p}
            </p>)}
        </div>
        <ul className="mt-5 flex flex-wrap gap-2" data-id="element-30" data-mp="fi8t39dq705f">
          {bonus.highlights.map(h => <li key={h} className="whitespace-nowrap rounded-full border border-pumpkin/40 bg-pumpkin/10 px-3 py-1 text-[12px] font-semibold text-pumpkin-light" data-id="element-31" data-mp="t9vu1mim4wuj">
              {h}
            </li>)}
        </ul>
        {bonus.emotional && <p className="mt-5 font-display text-lg italic leading-snug text-cream-100" data-id="element-32" data-mp="ybl2cuegawex">{bonus.emotional}</p>}
      </div>
    </article>;
}